import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'doubts',
    lazy: async () => ({ Component: (await import('./DoubtsPage')).DoubtsPage }),
  },
];
